import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API from "@/lib/api";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await API.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1600);
    } catch (err) {
      setError(err.response?.data?.detail || "This reset link is invalid or has expired. Please request a new one.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-sm p-8" data-testid="reset-password-page">
        <h1 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Choose a new password</h1>
        {done ? (
          <p className="text-sm text-emerald-700 mt-3" data-testid="reset-success">Your password has been reset. Redirecting you to sign in…</p>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-4">
            <div>
              <label htmlFor="rp-password" className="text-sm font-medium text-slate-700">New password</label>
              <input
                id="rp-password" type="password" required autoComplete="new-password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:border-[#100f5d] focus:ring-1 focus:ring-[#100f5d] outline-none text-sm"
                data-testid="reset-password-input" placeholder="At least 8 characters"
              />
            </div>
            <div>
              <label htmlFor="rp-confirm" className="text-sm font-medium text-slate-700">Confirm new password</label>
              <input
                id="rp-confirm" type="password" required autoComplete="new-password" value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:border-[#100f5d] focus:ring-1 focus:ring-[#100f5d] outline-none text-sm"
                data-testid="reset-confirm-input" placeholder="Re-enter your new password"
              />
            </div>
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm" data-testid="reset-error">{error}</div>
            )}
            <button type="submit" disabled={busy}
              className="w-full h-11 rounded-lg text-white font-semibold text-sm transition-colors disabled:opacity-60"
              style={{ background: "#100f5d" }} data-testid="reset-submit-btn">
              {busy ? "Saving…" : "Set new password"}
            </button>
            <button type="button" onClick={() => navigate("/login")} className="w-full text-sm text-slate-500 hover:text-slate-700" data-testid="reset-cancel">
              Back to sign in
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
